import React, { Component } from "react";
import "./program-select.component.css";

export class ProgramSelectComponent extends Component {
  programs = [];
  constructor(props) {
    super(props);
    this.state = {
      selectedPrograms: [],
      availablePrograms: this.props.available_programs,
      showButton: true,
      apiURL: this.props.api || "http://localhost:3000",
      locked: false,
    };
  }

  displayPrograms(self) {
    const { selectedPrograms, availablePrograms } = this.state;

    return availablePrograms.map((program) => (
      <ProgramSelectButton
        key={program}
        image={program}
        selected={selectedPrograms.includes(program)}
        togglePrograms={(a, b) => this.togglePrograms(a, b)}
      />
    ));
  }

  togglePrograms(program_name, add_subtract) {
    const { selectedPrograms, locked } = this.state;
    if (locked) return;

    // Create a new Set from selectedPrograms to ensure uniqueness
    const programsSet = new Set(selectedPrograms);

    if (add_subtract === "add") {
      programsSet.add(program_name);
    } else {
      programsSet.delete(program_name);
    }

    // Convert Set back to array
    const programs = Array.from(programsSet);
    this.setState({ selectedPrograms: programs });
  }
  submit() {
    const { triggerNextStep } = this.props;
    const { selectedPrograms } = this.state;
    this.setState({ showButton: false, locked: true });
    triggerNextStep({ value: selectedPrograms });
  }

  render() {
    const { showButton, selectedPrograms } = this.state;
    return (
      <div className="program-select-root">
        <div className="program-select-grid">
          {this.displayPrograms(this)}
          {selectedPrograms.length ? (
            <SelectProgramsButtonComponent
              display={showButton}
              label={"Next"}
              callback={() => this.submit()}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

const ProgramSelectButton = ({ image, selected, togglePrograms }) => {
  const getImage = () =>
    image.replace(/\s/g, "-").replace(/&/g, "and").toLowerCase();

  const toggleButton = () => {
    const newSelect = !selected;
    const action = newSelect ? "add" : "remove";
    togglePrograms(image, action);
  };

  let suffix = "";
  if (selected) {
    suffix = "-selected";
  }

  return (
    <button
      type="button"
      aria-pressed={selected}
      aria-label={image}
      className={`program-select-tile ${selected ? "program-select-tile--selected" : ""}`}
      onClick={toggleButton}
    >
      <img
        alt=""
        aria-hidden
        src={`/assets/servicebot-icons/${getImage()}${suffix}.png`}
        className="program-select-tile__img"
      />
    </button>
  );
};

const SelectProgramsButtonComponent = ({ label, display, callback }) => {
  if (!display) return null;

  return (
    <button
      type="button"
      className="servicebot-primary-action program-select-next"
      onClick={callback}
    >
      {label}
    </button>
  );
};
